import type { Repo } from './repo.ts';

/**
 * Calls to our Cloudflare Worker (/api). Same origin in production; VITE_API_BASE points the Vite dev
 * server at `wrangler dev`. Every call is best-effort: training never waits on, or fails because of, the API.
 */
const BASE = ((import.meta.env.VITE_API_BASE as string | undefined) ?? '').replace(/\/$/, '');

async function token(repo: Repo): Promise<string | null> {
  return repo.auth ? repo.auth.accessToken() : null;
}

export async function api(repo: Repo, path: string, init: RequestInit = {}, auth = true): Promise<Response | null> {
  try {
    const headers = new Headers(init.headers);
    if (auth) {
      const t = await token(repo);
      if (!t) return null;
      headers.set('Authorization', `Bearer ${t}`);
    }
    if (init.body) headers.set('Content-Type', 'application/json');
    return await fetch(`${BASE}/api${path}`, { ...init, headers });
  } catch {
    return null; // offline or Worker unreachable: fine
  }
}
